import { useContext } from 'react'
import { APP_URL, uploadPath } from '@helpers/variables'
import { AppContext } from '@state/context'

import Header from '@editorjs/header'
import List from '@editorjs/list'
// import ImageTool from '@editorjs/image'
import ImageTool from '@blocks/ImageTool' // Using Raket modified version
import Embed from '@editorjs/embed'
import Table from 'editorjs-table'

// Custom blocks
import { Quiz } from '@blocks/Quiz/editor'
import { DragWordToImage } from '@blocks/DragWordToImage/editor'
import { DragImageToCategory } from '@blocks/DragImageToCategory/editor'
import { WordExplanation } from '@blocks/WordExplanation/editor'
import { InstructionExercise } from '@blocks/InstructionExercise/editor'
import { DividerBlock } from '@blocks/Divider/editor'
import { AttachmentTool } from '@blocks/AttachmentTool/editor'
import { openExercisePanel } from '@state/actions/panelsActions'
import { PANELS } from './constants'
import { exerciseChanged } from '@state/actions/exercisesActions'
import { FontSizeTool } from '@blocks/FontSizeTool'

export const getEditorJsTools = (onSave) => {
  const [, dispatch] = useContext(AppContext)

  // Prevent sanitize on Table tool
  if (!Table.hasOwnProperty('sanitize')) {
    Object.defineProperty(Table, 'sanitize', {
      get: () => {
        return true
      },
    })
  }

  const config = {
    onChange: () => {
      dispatch(exerciseChanged())
    },
    onSave,
    openPanel: (getComponent) => {
      dispatch(
        openExercisePanel({
          panel: PANELS.EDIT_EXERCISE,
          exercise: {
            getComponent,
          },
        })
      )
    },
  }

  return {
    basic: {
      fontSize: {
        class: FontSizeTool,
      },
      header: {
        class: Header,
        inlineToolbar: ['bold', 'italic', 'link'],
      },
      list: {
        class: List,
        inlineToolbar: ['bold', 'italic', 'link'],
      },
      embed: Embed,
      table: {
        inlineToolbar: true,
        class: Table,
      },
      image: {
        class: ImageTool,
        inlineToolbar: true,
        config: {
          endpoints: {
            byFile: `${APP_URL}${uploadPath}`, // Your backend file uploader endpoint

            // @TODO, do we need internet-paste-functionality below, or is image-upload enough?
            // If so, below endpoint needs to be created
            // byUrl: 'http://localhost:8008/fetchUrl', // Your endpoint that provides uploading by Url
          },
          actions: [
            {
              name: 'withLightbox',
              icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.89954 10.545V13.965C1.89954 15.119 2.88454 16.055 4.09954 16.055H8.29953V13.918H4.14954V10.545H1.89954ZM1.89954 8.40799H4.14954V5.083H8.29953V2.945H4.09954C2.88454 2.945 1.89954 3.881 1.89954 5.035V8.40799ZM16.9495 10.545H14.6995V13.918H10.5495V16.055H14.7495C15.9645 16.055 16.9495 15.119 16.9495 13.965V10.545Z" /><path d="M16.4308 3.67069L12.3965 7.70497C12.2565 7.84493 12.0654 7.92233 11.8653 7.92012C11.6652 7.91792 11.4723 7.8363 11.3292 7.69321C11.1862 7.55013 11.1045 7.35731 11.1023 7.15716C11.1001 6.95702 11.1775 6.76594 11.3175 6.62598L15.3518 2.5917L11.9418 2.55462C11.8412 2.55598 11.7409 2.53718 11.6468 2.49933C11.5527 2.46148 11.4667 2.40534 11.3939 2.33422C11.321 2.2631 11.2629 2.17844 11.2228 2.08523C11.1827 1.99201 11.1615 1.89212 11.1604 1.79144C11.1593 1.69077 11.1784 1.59133 11.2165 1.499C11.2546 1.40667 11.311 1.32331 11.3823 1.25383C11.4536 1.18434 11.5384 1.13014 11.6318 1.09441C11.7251 1.05868 11.825 1.04215 11.9257 1.04579L17.157 1.10198C17.574 1.10705 17.9149 1.44801 17.9195 1.86447L17.9771 7.09724C17.9724 7.29257 17.892 7.47677 17.7528 7.61103C17.6136 7.74528 17.4265 7.81911 17.231 7.81696C17.0354 7.8148 16.8467 7.73684 16.7045 7.59948C16.5624 7.46213 16.4778 7.27611 16.4688 7.08062L16.4303 3.67021L16.4308 3.67069Z" /></svg>',
              title: 'Open in lightbox',
              // action: (name) => {
              //   console.log('name: ', name)
              //   // return true;
              // },
            },
          ],
        },
      },
      attaches: {
        class: AttachmentTool,
        inlineToolbar: true,
      },
      divider: {
        class: DividerBlock,
        inlineToolbar: true,
      },
    },
    // Custom tools
    exercises: {
      quiz: {
        class: Quiz,
        inlineToolbar: true,
        config,
      },
      dragWordToImage: {
        class: DragWordToImage,
        inlineToolbar: true,
        config,
      },
      dragImageToCategory: {
        class: DragImageToCategory,
        inlineToolbar: true,
        config,
      },
      wordExplanation: {
        class: WordExplanation,
        inlineToolbar: true,
        config,
      },
      instructionExercise: {
        class: InstructionExercise,
        inlineToolbar: true,
        config,
      },
    },
  }
}
